import Login from '../views/Auth/Login';
import Register from '../views/Auth/Register';
import Restore from '../views/Auth/Restore';
import NewPassword from '../views/Auth/NewPassword';

const routes = [
    {path: 'login',    name: 'Login',      component: Login,       meta : { layout : 'default', requiresAuth : false, title : 'Login'}},
    {path: 'register', name: 'Register',   component: Register,    meta : { layout : 'default', requiresAuth : false, title : 'Register'}},
    {path: 'restore',  name: 'Restore',    component: Restore,     meta : { layout : 'default', requiresAuth : false, title : 'Restore'}},
    {path: 'new-password', name: 'NewPassword', component: NewPassword, meta : { layout : 'default', requiresAuth : false, title : 'New Password'}},
]

export default routes;